// extracted by mini-css-extract-plugin
var _1 = "_2pOQnbCUExNap_YF8Kg";
var _2 = "_2pOQnbCUExNap_YF8Kg";
var _3 = "sxX2ea94prDBfOsUkTvK";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
